export default function(a, b) {
  return a - b;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-contour/src/ascending.js
// module id = ./node_modules/d3-contour/src/ascending.js
// module chunks = 54